import { useState, useCallback, useEffect } from "react";
import { Tooltip } from "../";
import {
  DEPLOY_STATUSES,
  INDEX,
  TIME_TO_ALLOW_REDEPLOY,
  EMPTY_ARRAY,
} from "../../../constants";
import Spinner from "../../organisms/Spinner";
import DeploymentModal from "../../organisms/AppModals/DeployBEModel/DeploymentModal";

const { REPO_NOT_FOUND } = DEPLOY_STATUSES;
const { FIRST } = INDEX;

const ReDeployButton = ({
  hasInvalidEndpoint,
  filteredEndpoints = EMPTY_ARRAY,
  isDeployBtnDisabled,
  deployStatus,
  hasEmptyEndpointsAndCollections,
  isMuleSoftSection,
  isDataModelSection,
  deploymentLogs,
  deployedAt,
  data,
  show,
  setShow,
  handleOnSubmit,
  tooltipPosition,
  isApplicationSection,
}) => {
  const [timer, setTimer] = useState();

  useEffect(() => {
    if (!deployedAt) return;
    const timerInterval = setInterval(() => {
      const timeRemaining = +deployedAt + TIME_TO_ALLOW_REDEPLOY - Date.now();
      if (timeRemaining > FIRST) {
        const minutes = String(
          Math.floor((timeRemaining / 1000 / 60) % 60)
        ).padStart(2, "0");
        const seconds = String(
          Math.floor((timeRemaining / 1000) % 60)
        ).padStart(2, "0");
        setTimer({ minutes, seconds });
      } else setTimer();
    }, 1000);
    return () => clearInterval(timerInterval);
  }, [deployedAt]);

  const getDeployButtonTooltip = useCallback(() => {
    if (timer)
      return `A re-deploy can trigger in ${timer.minutes} : ${timer.seconds} minutes`;
    else if (hasInvalidEndpoint) return "Some endpoints are invalid";
    else if (
      (isDataModelSection || isMuleSoftSection) &&
      !filteredEndpoints.length
    )
      return "Endpoints are required";
    else if (!isMuleSoftSection && hasEmptyEndpointsAndCollections)
      return "Collections are required";
    else
      return isDataModelSection || isMuleSoftSection
        ? "Deploy Endpoints"
        : "Deploy Application";
  }, [
    filteredEndpoints.length,
    hasInvalidEndpoint,
    hasEmptyEndpointsAndCollections,
    timer,
    isMuleSoftSection,
    isDataModelSection,
  ]);

  const getButtonName = () => {
    const isRepoNotFound = deployStatus === REPO_NOT_FOUND;

    if (isApplicationSection) {
      return isRepoNotFound ? "Deploy FE" : "Re-Deploy FE";
    } else if (isDataModelSection || isMuleSoftSection) {
      return isRepoNotFound ? "Deploy BE" : "Re-Deploy BE";
    }
  };

  return (
    <Tooltip
      message={getDeployButtonTooltip()}
      shouldShow={deployStatus}
      position={tooltipPosition}
    >
      <button
        type="submit"
        className="btn btn-primary w-full xs:w-auto h-auto"
        disabled={isDeployBtnDisabled}
        onClick={() => handleOnSubmit()}
      >
        <Spinner showSpinner={!deployStatus}>{getButtonName()}</Spinner>
      </button>
      {show && (
        <DeploymentModal
          setShow={setShow}
          show={show}
          deploymentLogs={deploymentLogs}
          data={data}
          isMuleSoftSection={isMuleSoftSection}
        />
      )}
    </Tooltip>
  );
};

export default ReDeployButton;
